import {Inject, LOCALE_ID, Pipe, PipeTransform} from '@angular/core';
import moment from "moment";
import {
  API_COMMON_DATE_TIME,
  API_COMMON_MONTH_YEAR,
  COMMON_DATE_MOMENT,
  COMMON_DATETIME_MOMENT,
  COMMON_DATETIME_MOMENT2,
  COMMON_DATETIME_MOMENT3,
  COMMON_TIME_MOMENT, DATE_FORMATS,
  DISPLAY_DATE_MOMENT,
  DISPLAY_DATETIME_MOMENT,
  DISPLAY_DATETIME_MOMENT_COMMA,
  DISPLAY_SHORT_DATETIME_MOMENT,
  DISPLAY_SHORT_DATETIME_MOMENT_OTHER_YEAR,
  DISPLAY_SHORT_DAY_MOMENT,
  DISPLAY_SHORT_DAYMONTH_MOMENT,
  DISPLAY_SHORT_MONTHYEAR_MOMENT,
  EXCEPTION_DATES
} from '@shared/constants';
import {formatDate} from '@angular/common';


type typeFormat =
  'displayDate'
  | 'displayDateTime'
  | 'commonDate'
  | 'commonDateTime'
  | 'shortDate'
  | 'shortDateTime'
  | 'shortDay'
  | 'shortDayMonth'
  | 'shortMonthYear'
  | 'shortDisplayDateTime'
  | 'shortDisplayDate'
  | 'commonDateTime2'
  | 'commonDateTime3'
  | 'commonTime'
  | 'commonTimeMonthYear'

/**
 * @todo: err
 * 2/07/2024 -> 07/02/2024
 * 31/07/2024 -> invalid date
 */
@Pipe({
  name: 'datePipe',
  standalone: false,
})
export class DatetimePipe implements PipeTransform {
  transform(val: any, type?: typeFormat): any {
    if (!val || EXCEPTION_DATES.includes(val) || !type || !this.isValidValue(val, type)) {
      return '';
    }

    let f;
    switch (type) {
      default:
      case 'commonDate':
        f = COMMON_DATE_MOMENT;
        break;
      case 'commonDateTime':
        f = COMMON_DATETIME_MOMENT;
        break;
      case 'commonDateTime2':
        f = COMMON_DATETIME_MOMENT2;
        break;
      case 'commonDateTime3':
        f = COMMON_DATETIME_MOMENT3;
        break;
      case 'displayDateTime':
        f = DISPLAY_DATETIME_MOMENT;
        break;
      case 'displayDate':
        f = DISPLAY_DATE_MOMENT;
        break;

      case 'shortDateTime':
        f = DISPLAY_SHORT_DATETIME_MOMENT;
        break;
      case 'shortDay':
        f = DISPLAY_SHORT_DAY_MOMENT;
        break;
      case 'shortDayMonth':
        f = DISPLAY_SHORT_DAYMONTH_MOMENT;
        break;

      case 'shortMonthYear':
        f = DISPLAY_SHORT_MONTHYEAR_MOMENT;
        break;

      case 'shortDisplayDateTime':
        if (this.compareYear(val)) {
          f = DISPLAY_SHORT_DATETIME_MOMENT_OTHER_YEAR
        } else {
          f = DISPLAY_SHORT_DATETIME_MOMENT
        }
        break;

      case 'shortDate':
      case 'shortDisplayDate':
        if (this.compareYear(val)) {
          f = DISPLAY_DATE_MOMENT
        } else {
          f = DISPLAY_SHORT_DAYMONTH_MOMENT
        }
        break;
      case 'commonTime':
        f = COMMON_TIME_MOMENT
        break;
      case 'commonTimeMonthYear':
        f = API_COMMON_MONTH_YEAR
        break;
    }
    if (!f) {
      return '';
    }

    return moment(val).format(f);
  }

  private isValidValue(val: any, type: typeFormat) {
    let isValid = true;
    switch (type) {
      case 'shortDisplayDateTime':
        if (!moment(val, API_COMMON_DATE_TIME, true).isValid()) {
          isValid = false;
        }
        break;
    }
    return isValid
  }

  /**
   * compareDate: mặc định là ngày hiện tại, nếu có giá trị thì so sánh với giá trị truyền vào
   */
  compareYear(date: string, compareDate = '') {
    const d = new Date(date);
    const cd = compareDate ? new Date(compareDate) : new Date();
    return (d.getFullYear() !== cd.getFullYear());
  }
}

/**
 * pipe timestamp
 */
@Pipe({
  name: 'datePipe2',
  standalone: false,
})
export class DatetimePipe2 implements PipeTransform {

  transform(timestamp: any, format?: string): any {
    if (!timestamp) return ''
    let t = Number(timestamp);
    if (t < 999999999999) t *= 1000;
    let f
    if (format) {
      switch (format) {
        case 'longDate':
          f = DATE_FORMATS.VI.LONG_DATE
          break;
        case 'dateTime':
          f = DISPLAY_DATE_MOMENT
          break;
        case 'dateTimeComa':
          f = DISPLAY_DATETIME_MOMENT_COMMA
          break;
        default:
          f = DISPLAY_DATETIME_MOMENT
      }
    }
    return moment(t).format(f);
  }
}


/**
 * short - M/d/yy, h:mm a - 6/15/15, 9:03 AM
 * medium - MMM d, y, h:mm:ss a - Jun 15, 2015, 9:03:01 AM
 * shortDate - M/d/yy - 6/15/15
 * mediumDate - MMM d, y - Jun 15, 2015
 */
@Pipe({name: 'time', standalone: false})
export class TimePipe implements PipeTransform {
  constructor(@Inject(LOCALE_ID) private locale_id:any) {
  }

  transform(value: any, format?: 'short' | 'medium' | 'shortDate' | 'mediumDate'): string {
    if (!value) {
      return '';
    }
    // Quy chuẩn thời gian về milliseconds
    let t = Number(value);
    if (t < 999999999999) t *= 1000;

    if (format) {
      return formatDate(t, format, this.locale_id);
    }

    return formatDate(t, 'short', this.locale_id);
  }
}
